import { LayoutDashboard } from "lucide-react";
import { EmptyState } from "../ui";

type EmptyDashboardStateProps = {
  tabName: string;
  onNew: () => void;
  onManageReports: () => void;
  onOpenLibrary: () => void;
};

export default function EmptyDashboardState({ tabName, onNew, onManageReports, onOpenLibrary }: EmptyDashboardStateProps) {
  return (
    <EmptyState
      className="h-full"
      icon={<LayoutDashboard size={40} />}
      title={`"${tabName}" has no tiles yet`}
      action={
        <p className="text-sm text-gray-400">
          <button onClick={onManageReports} className="text-blue-600 hover:underline">
            Pin reports
          </button>{" "}
          to add tiles,{" "}
          <button onClick={onNew} className="text-blue-600 hover:underline">
            create a new dashboard
          </button>{" "}
          with Brian, or{" "}
          <button onClick={onOpenLibrary} className="text-blue-600 hover:underline">
            import one from the library
          </button>
          .
        </p>
      }
    />
  );
}
